export default {
  practice_admin: 'Practice',
  location_admin: 'LocationRole',
}



// WEBPACK FOOTER //
// ./src/common/StaticResourceTypes.js